'use strict';

exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'admin']
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 327
// module chunks = 0